import { RouteObject, Outlet } from '@rocketlane/rocket-router';
import { CompanyPageTemplates } from 'components/pages/company-page-template/list';
import { CompanyPageTemplateV2Page } from 'components/pages/company-page-template-v2';
import { EmailPageTemplatePage } from 'components/pages/email-page-template/index';
import { EmailPageTemplatesList } from 'components/pages/email-page-template/list';
import { MeetingPageTemplatePage } from 'components/pages/meeting-page-template';
import { PeoplePageTemplates } from 'components/pages/people-page-template/list';
import { PeoplePageTemplateManagePage } from 'components/pages/people-page-template/manage-template';
import { MeetingPageTemplates } from 'components/pages/templates/meetings-page-templates';
import { TemplatesListLayout } from 'components/pages/templates/templates-list-layout';
import { ROUTE_PATHS } from './route-paths';
import { SecureRoute } from './secure-route';

export const templatesRoutes: RouteObject = {
  path: ROUTE_PATHS.TEMPLATES,
  element: (
    <SecureRoute>
      <Outlet />
    </SecureRoute>
  ),
  children: [
    {
      path: ROUTE_PATHS.MEETING_PAGE_TEMPLATE_LIST,
      element: <Outlet />,
      children: [
        {
          index: true,
          element: (
            <TemplatesListLayout>
              <MeetingPageTemplates isModuleFed={false} />
            </TemplatesListLayout>
          ),
        },
        {
          path: ROUTE_PATHS.MEETING_PAGE_TEMPLATE_EDIT,
          element: <MeetingPageTemplatePage isModuleFed={false} />,
        },
      ],
    },
    {
      path: ROUTE_PATHS.COMPANY_PAGE_TEMPLATE_LIST,
      element: <Outlet />,
      children: [
        {
          index: true,
          element: (
            <TemplatesListLayout>
              <CompanyPageTemplates />
            </TemplatesListLayout>
          ),
        },
        {
          path: ROUTE_PATHS.COMPANY_PAGE_TEMPLATE_EDIT,
          element: <CompanyPageTemplateV2Page />,
        },
      ],
    },
    {
      path: ROUTE_PATHS.PEOPLE_PAGE_TEMPLATE_LIST,
      element: <Outlet />,
      children: [
        {
          index: true,
          element: (
            <TemplatesListLayout>
              <PeoplePageTemplates />
            </TemplatesListLayout>
          ),
        },
        {
          path: ROUTE_PATHS.PEOPLE_PAGE_TEMPLATE_EDIT,
          element: <PeoplePageTemplateManagePage />,
        },
      ],
    },
    {
      path: ROUTE_PATHS.EMAIL_PAGE_TEMPLATE_LIST,
      element: <Outlet />,
      children: [
        {
          index: true,
          element: (
            <TemplatesListLayout>
              <EmailPageTemplatesList isModuleFed={false} />
            </TemplatesListLayout>
          ),
        },
        {
          path: ROUTE_PATHS.EMAIL_PAGE_TEMPLATE_EDIT,
          element: <EmailPageTemplatePage isModuleFed={false} />,
        },
      ],
    },
  ],
};
